import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from 'styletron-react';
import { staticColors } from '../../../const/colors/staticColors';
import { sizes } from '../../../const/sizes';
import { useTestIdAttribute } from '../../../hooks/useTestIdAttribute';
import { Icon } from '../../Icon/Icon';
import { Text } from '../../Text/Text';
import { FlexContainer } from '../FlexContainer';
const StyledAccountSection = styled('div', ({ $borderTop, $padding }) => ({
    borderTop: $borderTop,
    boxSizing: 'border-box',
    padding: $padding,
    width: '100%',
}));
const StyledAvatar = styled('div', ({ $backgroundColor, $size }) => ({
    alignItems: 'center',
    backgroundColor: $backgroundColor,
    borderRadius: '50%',
    display: 'flex',
    flexShrink: 0,
    height: $size,
    justifyContent: 'center',
    width: $size,
}));
export const SidebarAccountSection = ({ isCollapsed, initials, name, role, trailingElement, testId, padding = sizes.sidebar.accountPadding, borderTop = `${sizes.divider.thickness} solid ${staticColors.divider}`, avatarSize = sizes.sidebar.avatarSize, avatarBackgroundColor = staticColors.buttonDarkGreyBackground, }) => {
    const testIdAttribute = useTestIdAttribute(testId);
    const shouldShowAccountDetails = !isCollapsed;
    const maybeNameAndRole = shouldShowAccountDetails && (_jsxs(FlexContainer, { direction: 'column', verticalAlign: 'center', grow: 1, basis: 0, shrink: 0, minWidth: 0, children: [_jsx(Text, { variant: 's2', children: name }), _jsx(Text, { variant: 'b3', color: 'grey', children: role })] }));
    const maybeTrailingElement = shouldShowAccountDetails &&
        (trailingElement ?? (_jsx(Icon, { name: 'KeyboardArrowDown', color: 'greyLight' })));
    return (_jsx(StyledAccountSection, { ...testIdAttribute, $borderTop: borderTop, $padding: padding, children: _jsxs(FlexContainer, { verticalAlign: 'center', gap: '1/2', fullWidth: true, children: [_jsx(StyledAvatar, { $backgroundColor: avatarBackgroundColor, $size: avatarSize, children: _jsx(Text, { variant: 's2', color: 'white', children: initials }) }), maybeNameAndRole, maybeTrailingElement] }) }));
};
